import styled from '@emotion/styled'
import { IPossibleTableKey } from '@types'
import React from 'react'
import { NumericalIcon } from '../../assets/icons/numericalIcon'
import { CategoryIcon } from '../../assets/icons/categoryIcon'
import { DateIcon } from '../../assets/icons/dateIcon'
import { RemoveIcon } from '../../assets/icons/removeIcon'
import { AddIcon } from '../../assets/icons/addIcon'

interface Props {
  option: IPossibleTableKey
  onClick: (option: IPossibleTableKey) => void
  selected?: boolean
  show: boolean
}

/**
 * Componente Key option
 * @param option {IPossibleTableKey}
 * @param onClick {Function}
 * @param selected {boolean=}
 * @param show {boolean} flag per show/hide della sidebar
 * @component
 */
export const KeyOption: React.FC<Props> = ({
  option,
  onClick,
  selected,
  show,
}) => {
  return (
    <Container show={show}>
      <Icon data-cy={`option-icon-${option.name}`}>
        {option.type === 'float' && <NumericalIcon />}
        {option.type === 'categorical' && <CategoryIcon />}
        {option.type === 'integer' && <NumericalIcon />}
        {option.type === 'date' && <DateIcon />}
      </Icon>
      <Label data-cy={`option-label-${option.name}`}>{option.name}</Label>
      <Action
        onClick={() => onClick(option)}
        data-cy={`option-action-${option.name}`}
      >
        {selected ? <RemoveIcon /> : <AddIcon />}
      </Action>
    </Container>
  )
}

//region STYLE
const Container = styled.div<{ show: boolean }>`
  display: grid;
  grid-template-columns: ${({ show }) => (!show ? 'auto' : '30px 195px 30px')};
  gap: 5px;
  height: 30px;
  width: 100%;
  place-self: center;
`
const Icon = styled.div`
  place-self: center;
`
const Label = styled.div`
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const Action = styled.button`
  border-radius: 5px;
  width: 20px;
  height: 20px;
  background: var(--secondary);
  border: none !important;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  color: var(--text);
  place-self: center;
`
//endregion
